/**
 * playline-persistence client 配線: localStorage の構造化 playline state
 * (= versionVector / lastPlayedAt 付き) の read/write を集約する module。
 *
 * useAutoResumePlayline が read、 usePlaylineSync が write する共有 SSoT。
 * 生 playlineId のみを持つ既存 `playline/storage.ts` (= STORAGE_KEY "palimia.playlineId") とは別。
 */

export interface LocalPlaylineState {
  playlineId: string;
  versionVector: number;
  lastPlayedAt: string; // ISO 8601
}

const STORAGE_KEY = "palimia-playline-state";

export function readLocalPlaylineState(): LocalPlaylineState | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (raw === null) return null;
    const parsed = JSON.parse(raw) as Partial<LocalPlaylineState>;
    if (
      typeof parsed.playlineId !== "string" ||
      typeof parsed.versionVector !== "number" ||
      typeof parsed.lastPlayedAt !== "string"
    ) {
      return null;
    }
    return parsed as LocalPlaylineState;
  } catch {
    return null;
  }
}

export function writeLocalPlaylineState(state: LocalPlaylineState): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // localStorage 不可 (= private mode / quota) は silent skip、 sync は次回に委ねる
  }
}

export function clearLocalPlaylineState(): void {
  if (typeof window === "undefined") return;
  try {
    window.localStorage.removeItem(STORAGE_KEY);
  } catch {
    // silent
  }
}
